const getNowTime = () => {
  const timestamp = new Date().getTime()
  const pTime = window.localStorage.getItem('proofTime') || 0
  return parseInt(timestamp, 10) - parseInt(pTime, 10)
}

const proofTime = serverTime => {
  if (!serverTime) return
  const timestamp = new Date().getTime()
  const time = parseInt(timestamp, 10) - parseInt(serverTime, 10)
  window.localStorage.setItem('proofTime', time)
}

export {
  getNowTime,
  proofTime
}


// WEBPACK FOOTER //
// ./src/common/util/utils.js